import { useMutation } from "react-query";
import { addRole } from "../../../../../actions/Utilities/ModuleManagement";

export const useAddRoleData = () => {
  return useMutation(addRole);
};
export default useAddRoleData;
